
export enum ModuleExecutorParmsArgTypeCd {
	CONFIGURATION = 'Configuration',
	CONSTANT_DATASET = 'ConstantDataset',
	DATA_SET = 'DataSet',
	DYNAMIC_CONFIG = 'DynamicConfig',
	FILE = 'File',
	PERIOD_CODE = 'PeriodCode'}

